import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { SUPPORTED_LANGUAGES } from "../../utils/languageRouting";
import { Contact } from "lucide-react";

// Lazy load all components for code splitting and better performance
const Homepage = lazy(() => import("../../Homepage2"));
const RegistrationPage = lazy(() => import("../../pages/RegistrationPage"));
const LoginPage = lazy(() => import("../../pages/LoginPage"));
const KokobeoHomepages = lazy(() => import("../../Menu/Homepage"));
const ProfessionalDashboard = lazy(() => import("../../pages/Main/Professional"));
const TermsPage = lazy(() => import("../../pages/Main/Terms"));
const PrivacyPolicyPage = lazy(() => import("../../pages/Main/Policy"));
const CookiesPolicyPage = lazy(() => import("../../pages/Main/Cookies"));
const Messages = lazy(() => import("../../pages/Main/Messages"));
const SubscriptionPlans = lazy(() => import("../../Menu/plans"));
const CreditsPage = lazy(() => import("../../Menu/credits"));
const ProjectsPage = lazy(() => import("../../pages/Main/projects"));
const HelpCenter = lazy(() => import("../../Menu/help"));
const AboutPage = lazy(() => import("../../pages/Main/About"));
const InternationalHomepage = lazy(() => import("../../pages/Main/InternationalHomepage"));
const PlumberRegistration = lazy(() => import("../../pages/Main/PlumberRegistration"));
const PlumberRequestForm = lazy(() => import("../../pages/Main/PlumberRequestForm"));
const LawyerRequestForm = lazy(() => import("../../pages/Main/LawyerRequestForm"));
const PlumberProfile = lazy(() => import("../../pages/Main/PlumberProfile"));
const ProfessionalPlumberProfile = lazy(() => import("../../pages/Main/ProfessionalPlumberProfile"));
const ProfessionalSearch = lazy(() => import("../../pages/Main/ProfessionalSearch"));
const ClientDashboard = lazy(() => import("../../pages/Main/client"));
const FreelancerDashboard = lazy(() => import("../../pages/Main/professionalDashboard"));
const ProHomepage = lazy(() => import("../../pages/Main/Professional_Homepage"));
const InternationalProfessional = lazy(() => import("../../pages/Main/professional-international"));
const InternationalProfessionalsPage = lazy(() => import("../../pages/Main/International_Professionals_Page"));
const LocalProfessionalsPage = lazy(() => import("../../pages/Main/local_professionals"));
const InternationalProfessionalsProfile = lazy(() => import("../../pages/Main/int_professionals_profiles"));
const WalletPage = lazy(() => import("../../pages/Main/Wallet_Page"));
const InternationalProfessionalRegistration = lazy(() => import("../../pages/InternationalProfessionalRegistration"));
const ProgressDashboard = lazy(() => import("../../pages/progress"));
const OrdersDashboard = lazy(() => import("../../pages/myorders"));
const OffersDashboard = lazy(() => import("../../pages/MyOffers"));
const ProposalsDashboard = lazy(() => import("../../pages/MyProposals"));
const SupportTickets = lazy(() => import("../../pages/SupportTickets"));
const WalletDashboard = lazy(() => import("../../pages/WalletDashboard"));
const WithdrawHistory = lazy(() => import("../../pages/WithdrawalHistory"));
const ProfileSettings = lazy(() => import("../../pages/ProfessionalProfileSettings"));
const ChangePassword = lazy(() => import("../../pages/ChangePassword"));
const DeleteAccount = lazy(() => import("../../pages/DeleteAccount"));
const MessagesAndVideoCall = lazy(() => import("../../Menu/MessagesAndVideoCall"));
const CMyProfile = lazy(() => import("../../client/ClientProfile"));
const ClientRegistration = lazy(() => import("../../client/ClientRegistrationForm"));
const ClientSettings = lazy(() => import("../../client/ClientSettings"));
const ProgressPage = lazy(() => import("../../client/ClientProgress"));
const PostJobPage = lazy(() => import("../../client/PostaJob"));
const MyJobsPage = lazy(() => import("../../client/MyJobsPage"));
const MyOrdersPage = lazy(() => import("../../client/MyOrdersPage"));
const MyOffersPage = lazy(() => import("../../client/MyOffersPage"));
const CMessagesAndVideoCall = lazy(() => import("../../client/MessagesAndVideoCall"));
const ClientWalletPage = lazy(() => import("../../client/ClientWalletPage"));
const ClientSupportTickets = lazy(() => import("../../client/Client_Support_Tickets"));
const NotificationsPage = lazy(() => import("../../Menu/Notification"));
const ContactPage = lazy(() => import("../../Menu/Contact"));
const AboutPage2 = lazy(() => import("../../Menu/About"));
const MessagesAndVideoCall2 = lazy(() => import("../../Menu/MessagesAndVideoCall"));
const AboutPage02 = lazy(() => import("../../Menu2/About02"));
const MessagesAndVideoCall02 = lazy(() => import("../../Menu2/MessageAndVideoCall02"));
const NotificationsPage02 = lazy(() => import("../../Menu2/Notification02"));
const ContactPage02 = lazy(() => import("../../Menu2/Contact02"));
const HelpCenter02 = lazy(() => import("../../Menu2/Help02"));
const VerifyAccount02 = lazy(() => import("../../Menu2/verify02"));
const SubscriptionPlans02 = lazy(() => import("../../Menu2/plans02"));
const CreditsPage02 = lazy(() => import("../../Menu2/Credits02"));
const LocalProfessionalProfile = lazy(() => import("../../pages/Main/LocalProfessionalProfile"));
const LocalProfessionalSettings = lazy(() => import("../../pages/Main/LocalSettings"));
const InviteFriends = lazy(() => import("../../pages/InviteFriendsPage"));
const CategoriesAndLocation = lazy(() => import("../../pages/categories"));
const ClientReviewsSection = lazy(() => import("../../components/ui/ClientReviewsSection"));
const ProfessionalReviewsSection = lazy(() => import("../../components/ui/ProfessionalReviewsSection"));
const ReportsPage = lazy(() => import("../../client/reports"));
const LocationManagement = lazy(() => import("../../Admin/FORM MANAGEMENT/LocationManagement"));
const Favorites = lazy(() => import("../../pages/Favorites"));
const Favorites2 = lazy(() => import("../../pages/Favorites"));
const Favorites22 = lazy(() => import("../../pages/Favorites2"));
const Favorites222 = lazy(() => import("../../pages/Favorites22"));
const ActiveJobs = lazy(() => import("../../pages/Main/ActiveJobs"));
const ClientProfile = lazy(() => import("../client/components/ClientProfile1"));
const ClientProfileSettings = lazy(() => import("../client/components/ClientProfileSettings"));
const MyProfile = lazy(() => import("../professional/components/MyProfile"));
const MySettings = lazy(() => import("../professional/components/MySettings"));
const VerifyAccount = lazy(() => import("../main/components/menu/Verify"));
const QuotesComponent = lazy(() => import("../admin/components/QuotesComponent"));
const AllJobsComponent = lazy(() => import("../admin/components/AllJobsComponent"));
const RefundRequestsPage = lazy(() => import("../../pages/RefundRequestsPage"));
const ClientInvoice = lazy(() => import("../../pages/ClientInvoice"));
const ProfessionalInvoice = lazy(() => import("../../pages/ProfessionalInvoice"));

// Base routes without language prefix
const baseRoutes: RouteObject[] = [
    { path: "/", element: <Homepage /> },
    { path: "/register", element: <RegistrationPage /> },
    { path: "/login", element: <LoginPage /> },
    { path: "/Homepage", element: <Homepage /> },
    { path: "/Terms", element: <TermsPage /> },
    // { path: "/Policy", element: <PrivacyPolicyPage /> },
    { path: "/Cookie", element: <CookiesPolicyPage /> },
    { path: "/projects", element: <ProjectsPage /> },
    { path: "/internationalhompage", element: <ProHomepage /> },
    { path: "/plumberregistration", element: <PlumberRegistration /> },
    { path: "/plumberrequestform", element: <PlumberRequestForm /> },
    { path: "/lawyerRequestForm", element: <LawyerRequestForm /> },
    { path: "/plumberprofile", element: <PlumberProfile /> },
    { path: "/professionalplumberprofile", element: <ProfessionalPlumberProfile /> },
    // { path: "/professionalSearch", element: <ProfessionalSearch /> },
    // { path: "/clients", element: <ClientDashboard /> },
    { path: "/Professionals", element: <FreelancerDashboard /> },
    { path: "/international-professionals", element: <AllJobsComponent jobType="international" /> },
    { path: "/jobs", element: <InternationalProfessionalsPage /> },
    { path: "/activejobs", element: <ActiveJobs /> },
    { path: "/professional", element: <AllJobsComponent /> },
    { path: "/local-professionals", element: <LocalProfessionalsPage /> },
    { path: "/professional-international", element: <InternationalProfessionalsProfile /> },
    { path: "/walletd", element: <WalletPage /> },
    { path: "/local/myprofile", element: <LocalProfessionalProfile /> },
    { path: "/local/settings", element: <LocalProfessionalSettings /> },
    { path: "/invite", element: <InviteFriends /> },
    { path: "/categories", element: <CategoriesAndLocation /> },
    { path: "/locationmanagement", element: <LocationManagement /> },
    { path: "/myprofile", element: <MyProfile /> },
    { path: "/Settings", element: <MySettings /> },
    { path: "/international_professional_registration", element: <InternationalProfessionalRegistration /> },
    { path: "/Progress", element: <ProgressDashboard /> },
    { path: "/myorders", element: <OrdersDashboard /> },
    { path: "/myoffers", element: <OffersDashboard /> },
    { path: "/myproposals", element: <ProposalsDashboard /> },
    { path: "/support", element: <SupportTickets /> },
    { path: "/wallet", element: <WalletDashboard /> },
    { path: "/withdrawalhistroy", element: <WithdrawHistory /> },
    { path: "/profilesettings", element: <ProfileSettings /> },
    { path: "/changepassword", element: <ChangePassword /> },
    { path: "/DeleteAccount", element: <DeleteAccount /> },
    { path: "/MessageAndVideoCall", element: <MessagesAndVideoCall2 /> },
    { path: "/client/registration", element: <ClientRegistration /> },
    { path: "/client/settings", element: <ClientSettings /> },
    { path: "/client/progress", element: <ProgressPage /> },
    { path: "/postajob", element: <PostJobPage /> },
    { path: "/myjobs", element: <MyJobsPage /> },
    // { path: "/client/myorders", element: <MyOrdersPage /> },
    { path: "/client/myoffers", element: <MyOffersPage /> },
    { path: "/client/MessageAndVideoCall", element: <MessagesAndVideoCall2 /> },
    { path: "/client/Wallet", element: <ClientWalletPage /> },
    { path: "/client/profilesettings", element: <ClientProfileSettings /> },
    { path: "/client/support", element: <ClientSupportTickets /> },
    { path: "/about", element: <AboutPage2 /> },
    { path: "/how-it-works", element: <KokobeoHomepages /> },
    { path: "/menu/messages", element: <MessagesAndVideoCall2 /> },
    { path: "/notifications", element: <NotificationsPage /> },
    { path: "/menu/contact", element: <ContactPage /> },
    { path: "/help", element: <HelpCenter /> },
    { path: "/client/profile", element: <ClientProfile /> },
    { path: "/client/reports", element: <ReportsPage /> },
    { path: "/verify", element: <VerifyAccount /> },
    { path: "/plans", element: <SubscriptionPlans /> },
    { path: "/credits", element: <CreditsPage /> },
    { path: "/client/myorders", element: <MyOrdersPage /> },
    { path: "/client/reviews", element: <ClientReviewsSection /> },
    { path: "/professional/reviews", element: <ProfessionalReviewsSection /> },
    { path: "/international/about", element: <AboutPage02 /> },
    { path: "/international/menu/messages", element: <MessagesAndVideoCall02 /> },
    { path: "/international/notifications", element: <NotificationsPage02 /> },
    { path: "/international/menu/contact", element: <ContactPage02 /> },
    { path: "/international/help", element: <HelpCenter02 /> },
    { path: "/international/verify", element: <VerifyAccount02 /> },
    { path: "/international/plans", element: <SubscriptionPlans02 /> },
    { path: "/international/credits", element: <CreditsPage02 /> },
    { path: "/client/favorites", element: <Favorites22 /> },
    { path: "/professional/favorites", element: <Favorites222 /> },
    { path: "/refund-requests", element: <RefundRequestsPage isClient={false} /> },
    { path: "/client/refund-requests", element: <RefundRequestsPage isClient={true} /> },
    { path: "/client/invoices", element: <ClientInvoice /> },
    { path: "/invoices", element: <ProfessionalInvoice /> },
    { path: "/client/profile/:userId", element: <ClientProfile /> },
    { path: "/myprofile/:userId", element: <MyProfile /> },
];

/**
 * Create language-prefixed routes
 * Generates routes for each supported language (e.g., /it/professional, /es/clients)
 */
const createLanguagePrefixedRoutes = (routes: RouteObject[]): RouteObject[] => {
  const languagePrefixedRoutes: RouteObject[] = [];
  
  // Create routes for each language (except English which is the default)
  SUPPORTED_LANGUAGES.filter(lang => lang !== "en").forEach(lang => {
    routes.forEach(route => {
      if (route.path) {
        if (route.path === "/") {
          // For root path, add language prefix: /it, /es, etc.
          languagePrefixedRoutes.push({
            ...route,
            path: `/${lang}`,
          });
        } else {
          // Add language prefix: /it/professional
          languagePrefixedRoutes.push({
            ...route,
            path: `/${lang}${route.path}`,
          });
          
          // Also add language suffix for backward compatibility: /professional/it
          languagePrefixedRoutes.push({
            ...route,
            path: `${route.path}/${lang}`,
          });
        }
      }
    });
  });
  
  return languagePrefixedRoutes;
};

// Export both base routes and language-prefixed routes
const AppBackRoute: RouteObject[] = [
  ...baseRoutes,
  ...createLanguagePrefixedRoutes(baseRoutes),
];

export default AppBackRoute;